export default (required, optional) =>
  required !== undefined || optional !== undefined ? !!required : undefined
